import React from "react";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { DocumentSourcesPanel } from "../../components/generic/documentSourcePanel/DocumentSourcesPanel";

export const DocumentSourcesPage: React.FunctionComponent = () => {
  return (
    <CoRetrieveDocumentData shouldFetchDocumentPart={true}>
      {({ coObject, documentPart }) =>
        coObject?.documentId ? (
          <DocumentSourcesPanel idPartRoot={coObject.documentId} documentPart={documentPart} />
        ) : (
          <DocumentNotValidError />
        )
      }
    </CoRetrieveDocumentData>
  );
};
